// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3wy06","lg":"header_lg__2YjKC","sm":"header_sm__1g0KE","custom":"header_custom__155ns"};